module.exports = {
  optionA:{
    일반 : 0.7,
    확장 : 0.8,
    팝업 : 0.8,
    전면 : 1,
  },
  data: {
    initvalue : {
      weight: 1
    },
    device : {
      pcWeight : 0.8333333,
      pcStatic : 2073600,
      moWeigth : 1,
      moStatic : 230400,
    },
    banner : {
      일반 : 0.7,
      확장형 : 0.8,
      팝업 : 0.8,
      전면 : 1,
    },
    sitePosition1 : {
      최상단 : 1,
      중간 : 0.8333333,
      하단 : 0.6666667,
    },
    sitePosition2 : {
      메인 : 0.8333333,
      서브 : 0.6666667,
      팝업 : 1
    },
    movement : {
      일반 : 0.8333333,
      확장형 : 1,
      팝업 : 1,
    },
    mediaType : {
      이미지 : 0.8333333,
      텍스트 : 0.6666667,
      이미지동영상 : 1, // 이미지+동영상
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/common/WeightDB.js